import { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "../../../components/MuiGenerals";
import { usePermission, useTranslation } from "../../../hooks";
import { Pkey, translatePrefix } from "./config";
import {
  ReduxProvider,
  resetMerchantTabParams,
  resetLiquidityProviderParams,
  useReduxContext,
} from "./reduxContext";
import MerchantTab from "./MerchantTab";
import LiquidityProviderTab from "./LiquidityProviderTab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Content = () => {
  const [_, dispatch] = useReduxContext();
  const { hasPermission } = usePermission();
  const [tabsIndex, setTabsIndex] = useState(0);
  const { t } = useTranslation(translatePrefix);

  useEffect(() => {
    dispatch(resetLiquidityProviderParams());
    dispatch(resetMerchantTabParams());
  }, [tabsIndex]);

  const tabs = [
    {
      name: "merchant_tab",
      path: Pkey.TabMerchant.prefix,
      jsxNode: <MerchantTab />,
    },
    {
      name: "liquidity_provider_tab",
      path: Pkey.TabLiquidityProvider.prefix,
      jsxNode: <LiquidityProviderTab />,
    },
  ].filter((item) => hasPermission(item.path));

  return (
    <Box
      sx={{
        backgroundColor: "white",
        paddingTop: "2rem",
      }}
    >
      <Tabs
        sx={{
          margin: "0 1.5rem",
          borderBottom: "solid #E1E4EA 1px",
        }}
        value={tabsIndex}
        onChange={(_, newValue) => setTabsIndex(newValue)}
      >
        {tabs.map((item, index) => (
          <Tab key={index} label={t(item.name)} {...a11yProps(index)} />
        ))}
      </Tabs>
      {tabs.map((item, index) => (
        <TabPanel key={index} value={tabsIndex} index={index}>
          {item.jsxNode}
        </TabPanel>
      ))}
    </Box>
  );
};

export default function CrossMerchantTransferPath() {
  return (
    <ReduxProvider>
      <Content />
    </ReduxProvider>
  );
}
